export default "__VITE_ASSET__b96c8bda__"